function bundle(e){
  
var title = ""  
console.log("bundle", e.title) /
console.log("bundle for false lashes") 
title = e.title;
  
 
var BundleOpt  = document.querySelector('[variant-title="2 Pack Bundle Set"]');
var SinglePairOpt = document.querySelector('[variant-title="1 Pair"]');
var addToCartBundle = document.querySelector('[name="add"]');
var bundleStyle1 = document.getElementById('bundlestyle1');
var bundleStyle2 = document.getElementById('bundlestyle2');  
var singleStyle = document.getElementById('singlestyle');

if (BundleOpt != undefined){
  
     var isSelected = hasClassHere(BundleOpt,"selected");
    
     console.log("isSelected", isSelected)
       
     if (isSelected ==true){
       		 
     document.getElementById('BundleOption').style.display = 'block';
     document.getElementById('SingleOption').style.display = 'none';
   
     }else{
                		 
     document.getElementById('SingleOption').style.display = 'block';
     document.getElementById('BundleOption').style.display = 'none';
  
     }
  
}

SinglePairOpt.onclick = function(){ 

   bundleStyle1.selectedIndex = "";
    bundleStyle2.selectedIndex = "";

  document.getElementById('SingleOption').style.display = 'block';
  document.getElementById('BundleOption').style.display = 'none';
  
  //remove require from bundle option

  
  removeClass(bundleStyle1,"required") 
  removeClass(bundleStyle2,"required") 
  
  if (hasClassHere(singleStyle,"required") == false){
     addClass(singleStyle,"required") 
  }
  
  
  


};
  

BundleOpt.onclick = function () { 
      
  singleStyle.selectedIndex = "";
  document.getElementById('SingleOption').style.display = 'none';
  document.getElementById('BundleOption').style.display = 'block';
  
    removeClass(singleStyle,"required") 

  
  if (hasClassHere(bundleStyle1,"required") == false){
     addClass(bundleStyle1,"required") 
  }
  
  if(hasClassHere(bundleStyle2,"required") == false){
     addClass(bundleStyle2,"required") 
  }
  

           
};  
 
};
  

  
function hasClassHere(ele,cls) {
  console.log("ele", ele)
return !!ele.className.match(new RegExp('(\\s|^)'+cls+'(\\s|$)'));
}

function addClass(ele,cls) {
  
if (!hasClass(ele,cls)) ele.className += " "+cls;
}

function removeClass(ele,cls) {
if (hasClass(ele,cls)) {
  var reg = new RegExp('(\\s|^)'+cls+'(\\s|$)');
  ele.className=ele.className.replace(reg,' ');
}
}

